"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetsContactWidget_de_de = void 0;
function widgetsContactWidget_de_de() {
    return {
        "widgets.contacts.columns.avatar": "Avatar",
        "widgets.contacts.columns.firstname": "Vorname",
        "widgets.contacts.columns.lastname": "Nachname",
        "widgets.contacts.columns.company": "Firma",
        "widgets.contacts.columns.email": "E-Mail",
        "widgets.contacts.columns.phone": "Telefon",
        "widgets.contacts.columns.mobile": "Mobil",
        "widgets.contacts.columns.actions": "Aktionen"
    };
}
exports.widgetsContactWidget_de_de = widgetsContactWidget_de_de;
